export default __webpack_public_path__ + "static/slide1-da248be72a0282d272b429d2f0e28a9c.jpg";